
export default () => ({
    loading: true,
    topics: [],
    currentTopic: null
})
